import React, { Component } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

import UIEnglishCourse from './english-course-list'
import UIEnglishCourseDetails from './english-course-details'
import UIEnglishCourseStudents from './english-course-students'

export default class EnglishCourse extends Component {
    render() {
        return (
            <Switch>
                <Route path='/learnpoints/course' component={UIEnglishCourse} exact /> {/*exact = 路徑完全匹配*/}
                <Route path='/learnpoints/course/details' component={UIEnglishCourseDetails} />
                <Route path='/learnpoints/course/students' component={UIEnglishCourseStudents} />
                <Redirect to='/learnpoints/course' />
            </Switch>
        )
    }
}